export default "__VITE_ASSET__BTEcPc46__"